export const actionConst = {
    FETCH_CONTRACTORS: 'FETCH_CONTRACTORS', 
    FETCH_DOCUMENT_CONTRACTORS: 'FETCH_DOCUMENT_CONTRACTORS',
};
